var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-full bg-redCadmium text-white p-6 flex flex-col" },
    [
      _c("h1", { staticClass: "font-whd text-white leading-9" }, [
        _vm._v("\n    ticket"),
        _c("br"),
        _vm._v("verkoop"),
        _c("br"),
        _vm._v("start op"),
        _c("br"),
        _vm._v(_vm._s(_vm.ticketStartDate)),
        _c("br"),
        _vm._v("om 12:00\n    uur\n  ")
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex justify-end items-end flex-grow" }, [
      _c("img", {
        staticClass: "w-56 sm:w-48 lg:w-40 xl:w-48 xxl:w-auto",
        attrs: { src: require("../../images/waves.svg"), alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/johntanyuehan/Workspace/devilbox/data/www/whd/htdocs/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/johntanyuehan/Workspace/devilbox/data/www/whd/htdocs/wp-content/themes/wereldhavendagen/node_modules/vue-loader/lib?{}!./scripts/vue/TicketverkoopCard.vue?vue&type=template&id=517d81f0&
// module id = 93
// module chunks = 0